import { render, staticRenderFns } from "./InvoiceComponent.vue?vue&type=template&id=b2b60c12&scoped=true"
import script from "./InvoiceComponent.vue?vue&type=script&lang=js"
export * from "./InvoiceComponent.vue?vue&type=script&lang=js"
import style0 from "./InvoiceComponent.vue?vue&type=style&index=0&id=b2b60c12&prod&scoped=true&lang=css"
import style1 from "./InvoiceComponent.vue?vue&type=style&index=1&id=b2b60c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b60c12",
  null
  
)

export default component.exports